export default function AboutConcept() {
  return (
    <section id="about" className="py-28 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Content */}
          <div>
            <p className="font-inter text-xs text-[#D4845C] uppercase tracking-[0.2em] font-medium mb-5">
              About PadelVillas
            </p>
            <h2 className="font-cormorant text-5xl lg:text-6xl font-light text-[#2C2C2C] leading-[1.1] mb-8">
              Sport. Travel. Luxury.<br />
              <em className="italic">Finally United.</em>
            </h2>
            <p className="font-inter font-light text-[#6B6B6B] text-base leading-relaxed mb-6">
              PadelVillas was built on a simple truth: millions of dedicated padel players love to travel, but they have no elegant, reliable way to find luxury villa accommodation that puts the court at the centre of their holiday experience.
            </p>
            <p className="font-inter font-light text-[#6B6B6B] text-base leading-relaxed mb-6">
              Our platform solves that. We bring together the finest private-court villas across the Mediterranean and beyond into one trusted destination for guests who refuse to compromise on either sport or comfort.
            </p>
            <p className="font-inter font-light text-[#6B6B6B] text-base leading-relaxed mb-10">
              Our <strong className="font-medium text-[#2C2C2C]">in-stay coach booking network</strong> means guests can arrange professional padel coaching from verified local coaches directly through PadelVillas, turning a villa stay into a full immersive padel retreat.
            </p>

            <div className="flex flex-wrap gap-6">
              {[
                { icon: 'ri-map-pin-2-line', label: 'Mediterranean focus' },
                { icon: 'ri-tennis-ball-line', label: 'Court-first curation' },
                { icon: 'ri-user-star-line', label: 'Coach booking network' },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#D4845C]/10">
                    <i className={`${item.icon} text-[#D4845C] text-sm`} />
                  </div>
                  <span className="font-inter text-sm text-[#2C2C2C] font-medium">{item.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative">
            <div className="w-full h-[500px] rounded-2xl overflow-hidden">
              <img
                src="https://storage.readdy-site.link/project_files/f5c2fbd2-009e-4007-925f-0a8e75ed6c39/1069cee8-bfd5-40f4-82c4-8c9ddbb500c5_padel.jpg?v=767d088bc6ba4de0f1142d3d76581d63"
                alt="Padel players at luxury villa court"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Accent quote card */}
            <div className="absolute -bottom-6 -left-6 bg-[#FAF8F5] rounded-2xl p-6 max-w-xs">
              <p className="font-cormorant text-lg italic text-[#2C2C2C] leading-snug mb-3">
                &ldquo;The intersection of luxury travel and premium sport: an untapped market with extraordinary potential.&rdquo;
              </p>
              <div className="flex items-center gap-2">
                <div className="w-6 h-px bg-[#D4845C]" />
                <span className="font-inter text-xs text-[#6B6B6B]">PadelVillas Founding Team</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
